export const mapCustomerOption = (customer) => ({
  value: Number(customer?.id || 0),
  label: String(customer?.businessName || customer?.clientName || '').trim(),
  customerId: Number(customer?.customerId || customer?.companyId || customer?.id || 0),
  isDefault: Number(customer?.default || customer?.isDefault || 0) === 1,
  meta: {
    id: Number(customer?.id || 0),
    customerId: Number(customer?.customerId || customer?.companyId || customer?.id || 0),
    default: Number(customer?.default || customer?.isDefault || 0) === 1 ? 1 : 0,
    clientName: String(customer?.clientName || '').trim(),
    rfc: String(customer?.rfc || '').trim(),
    businessName: String(customer?.businessName || '').trim(),
    cfdiUseCode: String(customer?.cfdiUseCode || customer?.cfdiUse || '').trim(),
    cfdiUse: String(customer?.cfdiUse || '').trim(),
    taxRegimeCode: String(customer?.taxRegimeCode || customer?.taxRegime || '').trim(),
    taxRegime: String(customer?.taxRegime || '').trim(),
    fiscalResidence: String(customer?.fiscalResidence || '').trim(),
  },
});

export const normalizeFiscalCodeOptions = (items) => {
  return (Array.isArray(items) ? items : [])
    .map((item) => {
      const raw = item && typeof item === 'object' ? item : {};
      const code = String(raw?.code || raw?.meta?.code || '').trim();
      const name = String(raw?.name || raw?.meta?.name || '').trim();
      const value = code !== '' ? code : String(raw?.value || raw?.id || '').trim();
      if (value === '') {
        return null;
      }

      const label = code !== '' && name !== '' ? `${code} - ${name}` : (name || value);
      return {
        value,
        label,
        meta: raw,
      };
    })
    .filter(Boolean);
};

export const mapSerialOption = (item) => ({
  value: Number(item?.id || 0),
  label: String(item?.serial || '').trim(),
  meta: {
    id: Number(item?.id || 0),
    folio: String(item?.folio ?? '').trim(),
    documentType: String(item?.document_type || '').trim(),
  },
});
